import { get } from 'lodash';
import { brandGuestDepthParams } from '../constants/globals';
import { brandModuleCodes } from '../containers/Rewards/config';

const isModuleListed = (moduleList, moduleCode) =>
  Array.isArray(moduleList) &&
  moduleList.some(
    (bModule) =>
      String(get(bModule, 'code', '')).toLowerCase() === String(moduleCode).toLowerCase() &&
      (get(bModule, 'isActive', false) || get(bModule, 'isBeta', false)),
  );

const isStartupModuleOn = (commonState, moduleCode) =>
  [get(commonState, 'modules', []), get(commonState, 'appStartupInfo.modules', [])].some(
    (moduleList) => isModuleListed(moduleList, moduleCode),
  );

/** Loyalty on Xeno = loyaltyApp + externalLoyalty modules both active in /appStartup. */
const isExternalLoyaltyBrand = (commonState) =>
  isStartupModuleOn(commonState, brandModuleCodes.loyaltyApp) &&
  isStartupModuleOn(commonState, brandModuleCodes.externalLoyalty);

export const withExtProfileDepth = (depth, commonState) => {
  if (!isExternalLoyaltyBrand(commonState)) return depth;
  const depthParams = String(depth || '')
    .split(',')
    .filter(Boolean);
  if (depthParams.includes(brandGuestDepthParams.extProfile)) return depth;
  return [...depthParams, brandGuestDepthParams.extProfile].join(',');
};
